module.exports = __webpack_public_path__ + "img/BGIMGHOME2.b0274bd2.png";